function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M24 .493V0H.505L.5-.001.495 0H0v24h24V.493zm-1 21.799L12.707 11.999 23 1.708zM1 1.706L11.292 12 1 22.292zM1.709 1h20.584L12 11.292zM12 12.706L22.293 23H1.707z"
});

function SvgPlaceholder(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _ref);
}

export default __webpack_public_path__ + "placeholder.2382d.svg";
export { SvgPlaceholder as ReactComponent };